<template>
  <div class="carousel" :style="{height: height}">
    <button
      @mouseenter="stopSing"
      @mouseleave="sing"
      class="iconfont pre-option btn-option"
      @click="cutIndex"
    >&#xe602;</button>
    <ul class="carousel-lists">
      <li
        v-for="(item,index) in picList"
        :class="['carousel-card',{'is-active':activeIndex === index},{'is-in-stage':instageIndex[0]===index || instageIndex[1]===index }]"
        :style="styleList[index]"
        :key="index"
        @mouseenter="stopSing"
        @mouseleave="sing"
      >
        <img @click="openNewPage(item.link)" :src="item.url" alt />
        <div v-show="activeIndex !== index" class="hover-bla" @click="activeIndex=index"></div>
      </li>
    </ul>
    <ul class="carousel-indicators">
      <li
        :class="['indicator',{'is-active':activeIndex === index-1}]"
        v-for="index in picList.length"
        :key="index"
        @click="activeIndex=index-1"
      >
        <span></span>
      </li>
    </ul>
    <button
      @mouseenter="stopSing"
      @mouseleave="sing"
      class="iconfont next-option btn-option"
      @click="addIndex"
    >&#xe66a;</button>
  </div>
</template>

<script>
export default {
  props: {
    picList: {
      type: Array,
      default: [
        {
          link: 'https://picsum.photos/900/360',
          title: '',
          type: ''
        },
        {
          link: 'https://picsum.photos/900/360',
          title: '',
          type: ''
        },
        {
          link: 'https://picsum.photos/900/360',
          title: '',
          type: ''
        }
      ]
    },
    height: {
      type: String,
      default: '360px'
    },
    width: {
      type: String,
      default: '900px'
    }
  },
  data() {
    return {
      activeIndex: 0,
      styleList: [],
      cd: 5,
      timer: null
    };
  },
  methods: {
    stopSing() {
      clearInterval(this.timer);
    },
    sing() {
      this.timer = setInterval(() => {
        if (this.cd === 0) {
          this.addIndex();
          this.cd = 5;
        } else {
          this.cd--;
        }
      }, 1000);
    },
    addIndex() {
      this.activeIndex =
        this.activeIndex + 1 > this.picList.length - 1
          ? 0
          : this.activeIndex + 1;
    },
    cutIndex() {
      this.activeIndex =
        this.activeIndex - 1 < 0
          ? this.picList.length - 1
          : this.activeIndex - 1;
    },
    openNewPage(link) {
      window.open(link);
    },
    initStyle() {
      this.styleList = [];
      this.picList.forEach((e, i) => {
        let width = document.querySelector('.carousel').offsetWidth;
        let translateX = '';
        let scale = '';
        let activeIndex = this.activeIndex;
        let Finstage = this.instageIndex[0];
        let Sinstage = this.instageIndex[1];
        let zIndex = 'auto';
        switch (i) {
          case activeIndex:
            translateX = width * 0.5 + parseInt(this.width) * -0.5;
            scale = '1';
            zIndex = '3';
            break;
          case Finstage:
            translateX = width * 0.25 - parseInt(this.width) * 0.5;
            scale = '1';
            zIndex = '2';
            break;
          case Sinstage:
            translateX = width * 0.25 + parseInt(this.width) * 0.5;
            scale = '1';
            zIndex = '1';
            break;
          default:
            scale = '1';
            zIndex = 'auto';
            if (i === Sinstage + 1 || i === 0) {
              translateX = width + parseInt(this.width);
            } else if (i < Finstage) {
              translateX = -parseInt(this.width);
            }
            break;
        }
        this.styleList.push({
          transform: `translateX(${translateX}px) scale(${scale})`,
          width: this.width,
          height: this.height,
          zIndex: zIndex
        });
      });
    }
  },
  computed: {
    instageIndex() {
      let instageIndex = [];
      let length = this.picList.length;
      instageIndex[0] =
        this.activeIndex - 1 < 0 ? length - 1 : this.activeIndex - 1;
      instageIndex[1] =
        this.activeIndex + 1 > length - 1 ? 0 : this.activeIndex + 1;
      return instageIndex;
    }
  },
  filters: {},
  watch: {
    activeIndex() {
      this.initStyle();
    }
  },
  mounted() {
    this.initStyle();
    // setInterval(() => {
    //   this.cutIndex();
    // }, 4000);
    this.sing();
  }
};
</script>

<style lang="less" scoped>
.carousel {
  position: relative;
  width: 100%;
  .carousel-lists {
    position: relative;
    overflow: hidden;
    height: 100%;
    width: 100%;
    .carousel-card {
      opacity: 0.1;
      display: inline-block;
      height: 100%;
      transition: transform 0.4s ease-in-out, opacity 0.2s ease-in-out;
      position: absolute;
      text-align: center;
      img {
        cursor: pointer;
        height: 100%;
      }
      .hover-bla {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background-color: rgba(0, 0, 0, 0.2);
        transition: background 0.2s ease-in-out;
      }
    }
    .is-active {
      opacity: 1;
      z-index: 2;
      .hover-bla {
        // display: none;
        background-color: rgba(0, 0, 0, 0);
      }
    }
    .is-in-stage {
      z-index: 1;
      opacity: 1;
    }
  }
  .carousel-indicators {
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
    .indicator {
      cursor: pointer;
      margin: 0 5px;
      padding: 3px 1px;
      display: inline-block;
      span {
        display: block;
        width: 12px;
        height: 4px;
        background: rgba(255, 255, 255, 0.3);
        border-radius: 2px;
      }
    }
    .is-active {
      span {
        width: 24px;
        height: 4px;
        background: rgba(255, 255, 255, 1);
        border-radius: 2px;
      }
    }
  }
  .btn-option {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
    color: #fff;
    font-size: 40px;
    cursor: pointer;
    opacity: 0;
    transition: opacity 0.4s ease;
    background: none;
  }
  &:hover {
    .btn-option {
      opacity: 1;
    }
  }
  .pre-option {
    left: 10px;
  }
  .next-option {
    right: 10px;
  }
}
</style>
